/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { bindAllClassMethodsToThis, parseBoolean } from '../../../../../utils';
import BucketingBL from './bucketingLogicHelper';
import {
  findCategoryIdandName,
  isSearch,
  matchValue,
  getCategoryKey,
  getCatId,
  getDesiredNav,
  getSeoKeywordOrCategoryIdOrSearchTerm,
  isCatIdBucketingSeq,
  isRequiredChildrenExists,
  getCatIdUbxd,
  getDesiredL3,
  isRequiredL2L1,
  getBreadCrumb,
  getRequiredCategoryData,
  getPlpCutomizersFromUrlQueryString,
  visibleCategoryCount,
  getBreadcrumbCatId,
  getCatById,
  getCategoryFilters,
} from './ProductListing.util';
import { isSearched } from '../../SearchDetail/container/SearchDetail.util';
import { getLastLoadedPageNumber, getAppliedSortId } from './ProductListing.selectors';
import {
  PRODUCTS_PER_LOAD,
  routingInfoStoreView,
  PROMOTIONAL_PRODUCTS_URL,
} from './ProductListing.constants';

/* calculate the total number of products based on the categoriesset to display to customer i.e Phantom categories */
function getTotalProductsCount(updatedAvailableL3) {
  return updatedAvailableL3.reduce((total, { count }) => total + count, 0);
}

export default class ProductsOperator {
  constructor() {
    this.resetBucketingConfig();
    this.shouldApplyUnbxdLogic = true;
    if (bindAllClassMethodsToThis) bindAllClassMethodsToThis(this);
  }

  // eslint-disable-next-line
  get bucketingLogic() {
    return new BucketingBL();
  }

  resetBucketingConfig = (productCount, productsFetchedInPreviousCall) => {
    const PRODUCTS_PER_LOAD_PLP = PRODUCTS_PER_LOAD;
    this.bucketingConfig = {
      start: 0,
      productsToFetchPerLoad: productCount || PRODUCTS_PER_LOAD_PLP,
      productsFetchedInPreviousCall,
      L3Left: [],
      currL2NameList: [],
      bucketingSeqScenario: false,
      availableL3: [],
    };
  };

  getImgPath(id, excludeExtension, imageExtension) {
    return {
      colorSwatch: this.getSwatchImgPath(id, excludeExtension),
      productImages: this.getProductImagePath(id, excludeExtension, imageExtension),
    };
  }

  getNextChildItem = (listOfGroups, currItm, trgtChildItm, targetId) => {
    let newTrgtChildItm = trgtChildItm;
    listOfGroups.forEach((groupName) => {
      if (
        currItm.subCategories[groupName] &&
        currItm.subCategories[groupName].items &&
        currItm.subCategories[groupName].items.length
      ) {
        // If the category ID does not matches up then recursively call the same function to search depe down the tree.
        newTrgtChildItm = this.shouldBucktSeq(
          currItm.subCategories[groupName].items.length
            ? currItm.subCategories[groupName].items
            : currItm.subCategories[groupName],
          targetId,
          newTrgtChildItm
        );
      }
    });
    return newTrgtChildItm;
  };

  getSwatchImgPath = () => {
    return null;
  };

  getProductImgPath = (id, excludeExtension) => {
    const imgHostDomain = routingInfoStoreView.getOriginImgHostSetting();

    return {
      125: `${imgHostDomain}/wcsstore/GlobalSAS/images/tcp/products/125/${id}${
        excludeExtension ? '' : '.jpg'
      }`,
      380: `${imgHostDomain}/wcsstore/GlobalSAS/images/tcp/products/380/${id}${
        excludeExtension ? '' : '.jpg'
      }`,
      500: `${imgHostDomain}/wcsstore/GlobalSAS/images/tcp/products/500/${id}${
        excludeExtension ? '' : '.jpg'
      }`,
      900: `${imgHostDomain}/wcsstore/GlobalSAS/images/tcp/products/900/${id}${
        excludeExtension ? '' : '.jpg'
      }`,
    };
  };

  getProductImagePath = (id, excludeExtension, imageExtension) => {
    const imageName = (id && id.split('_')) || [];
    const imagePath = imageName[0];
    const extension = imageExtension ? `.${imageExtension}` : '.jpg';

    return {
      125: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
      380: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
      500: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
      900: `${imagePath}/${id}${excludeExtension ? '' : extension}`,
    };
  };

  getFacetSwatchImgPath = (id) => {
    const imgHostDomain = routingInfoStoreView.getOriginImgHostSetting();
    return `${imgHostDomain}/wcsstore/GlobalSAS/images/tcp/category/color-swatches/${id}.gif`;
  };

  getNavAttributes = (navTree, breadcrumbCatIds, attribute) => {
    let extractCat = {};
    breadcrumbCatIds.forEach((breadCrumbId, index) => {
      if (index === 0) {
        extractCat = getCatById(navTree, breadCrumbId);
      } else if (index === 1 && extractCat.subCategories && extractCat.subCategories) {
        Object.values(extractCat.subCategories).some((l2Category) => {
          const extractL2Cat = getCatById(l2Category.items, breadCrumbId);
          if (extractL2Cat) {
            extractCat = extractL2Cat;
            return true;
          }
          return false;
        });
      } else if (index === 2) {
        extractCat = getCatById(extractCat.subCategories, breadCrumbId);
      }
    });
    return extractCat && extractCat.categoryContent ? extractCat.categoryContent[attribute] : '';
  };

  fetchFiltersAndCount = (filters, categoryId, categoryNameList, location, pageNumber) => {
    // We need to send some extra params in query string in L2 to fetch the filters, available L3 and the product count in each L3.
    const extraParams = {
      'facet.multilevel': 'categoryPath',
      'f.categoryPath.nameId': true,
      'f.categoryPath.max.depth': 4,
    };
    // const isHideBundleProduct = abTestingStoreView.getIsHideBundleProduct(this.store.getState());
    return {
      seoKeywordOrCategoryIdOrSearchTerm: '',
      isSearch: '',
      filtersAndSort: filters,
      pageNumber,
      getImgPath: this.getImgPath,
      categoryId,
      breadCrumbs: '',
      bucketingSeqConfig: '',
      getFacetSwatchImgPath: this.getFacetSwatchImgPath,
      isUnbxdSequencing: '',
      excludeBadge: '',
      startProductCount: 0,
      numberOfProducts: 0,
      cacheFiltersAndCount: true,
      extraParams,
      shouldApplyUnbxdLogic: this.shouldApplyUnbxdLogic,
      hasShortImage: false,
      categoryNameList,
      location,
      isFetchFiltersAndCountReq: true,
    };
    // isHideBundleProduct);
  };

  getCurrentItems = (currItm) => {
    const listOfGroups = Object.keys(currItm.subCategories);
    listOfGroups.forEach((groupName) => {
      return (
        currItm.subCategories[groupName] &&
        currItm.subCategories[groupName].items &&
        currItm.subCategories[groupName].items.length &&
        currItm.subCategories[groupName].items
      );
    });
  };

  /** @function This function return the L3 items of the requested category id of L2.
   * @param navTree {Object} The vaigation free of left navigation.
   * @param targetId {String} The category ID of L2 whose children we need.
   * @param trgtChildItm {Array} The resultant desired array of all L3.
   * @return trgtChildItm {Array} The resultant desired array of all L3.
   */
  shouldBucktSeq(navTree, targetId, trgtChildItm) {
    const navTreeLength = navTree.length;
    let newTrgtChildItm = trgtChildItm || [];
    for (let idx = 0; idx < navTreeLength; idx += +1) {
      const currItm = navTree[idx];
      // Check if the category of the navigation bieng looped on matches with desired L2 category ID.
      if (
        currItm.categoryId === targetId ||
        (currItm.categoryContent && currItm.categoryContent.id === targetId)
      ) {
        // If subCategories has length, it means it doesn't have grouping
        // else it has grouping -> check groups and return current item
        newTrgtChildItm = currItm.subCategories.length
          ? currItm.subCategories
          : this.getCurrentItems(currItm);
        return newTrgtChildItm;
      }
      const listOfGroups = (currItm.subCategories && Object.keys(currItm.subCategories)) || [];
      newTrgtChildItm = this.getNextChildItem(listOfGroups, currItm, newTrgtChildItm, targetId);
    }
    return newTrgtChildItm;
  }

  processProductFilterAndCountData = (res, state, reqObj) => {
    const { categoryNameList, filtersAndSort, pageNumber, location } = reqObj;
    // We need to update the available L3 on the basis of the L2 call response. If the filters are applied then the available L3 gets changed.
    const updatedAvailableL3 = this.bucketingLogic.getUpdatedL3(
      res.availableL3InFilter,
      this.bucketingConfig.availableL3
    );
    this.bucketingConfig.availableL3 = [...updatedAvailableL3];
    this.bucketingConfig.L3Left = [...updatedAvailableL3];
    // const l2currentNavigationIds = res.currentNavigationIds;

    // We check if there is any L3 category available to make unbxd call else resolving promise
    if (!this.bucketingConfig.L3Left.length) {
      return null;
    }

    // We are checking if the scroll point is available or not. If yes then this is the case of browser back and we need to do achoring operation.
    // if(parseInt(getSessionStorage('SCROLL_POINT'), 10) || 0) {
    //   return this.fetchProductsCachedCount(categoryNameList, l2currentNavigationIds);
    // }
    categoryNameList.push(getRequiredCategoryData(this.bucketingConfig.L3Left[0]));
    // Making the category path of the L3 according to the sequence which is there in L3left.
    const categoryPathMap = categoryNameList
      ? categoryNameList
          .map((item) => item && (item.categoryId || item.categoryContent.id))
          .join('>')
      : '';
    // Making the L3 API Call.
    // return {
    //   state,
    //   filtersAndSort,
    //   pageNumber,
    //   location,
    //   start: this.bucketingConfig.start,
    //   productsToFetchPerLoad: this.bucketingConfig.productsToFetchPerLoad,
    //   categoryPathMap,
    // }

    return this.getProductsListingInfo({
      state,
      filtersAndSort,
      pageNumber,
      location,
      startProductCount: this.bucketingConfig.start,
      numberOfProducts: this.bucketingConfig.productsToFetchPerLoad,
      categoryPathMap,
    });
    // TODO - .then of the this.getProductsListingInfo is removed from here add it back
    // return null;
  };

  // eslint-disable-next-line
  getProductListingBucketedData(
    state,
    location,
    sortBySelected,
    filterAndSortParam = {},
    pageNumber = '',
    passedNavigationData,
    productCount,
    productsFetchedInPreviousCall,
    seoUrlPayload
  ) {
    this.resetBucketingConfig(productCount, productsFetchedInPreviousCall);
    let filtersAndSort;
    let categoryNameList;
    let clickedL2;
    let sortingAvailable;
    let isOutfitPage;
    ({
      filtersAndSort,
      categoryNameList,
      clickedL2,
      sortingAvailable,
      isOutfitPage,
      ...this.bucketingConfig
    } = this.bucketingLogic.doBucketingLogic(
      location,
      state,
      this.bucketingConfig,
      sortBySelected,
      filterAndSortParam,
      getPlpCutomizersFromUrlQueryString,
      productCount,
      seoUrlPayload
    ));
    // requiredChildren tell us the L3's available under L2 which has been clicked.
    const requiredChildren =
      clickedL2 && this.shouldBucktSeq(categoryNameList, clickedL2.categoryId);
    // isBuktSeqReq tells us if the bucketing is required or not. Bucketing is required only if the L2 which has been clicked has L3 under it.
    const isBuktSeqReq = requiredChildren && requiredChildren.length;
    const displayableCatCount = isBuktSeqReq ? visibleCategoryCount(requiredChildren) : 0;
    // If the sorting is available, which means that the user has clicked on sort by option , then we need to roll back to original approach.
    // Means we will need to trigger L2 call only and not mutiple L3's
    // Checking if the bucketing is required or not and click has not happened on L3.
    // Checking if the current page is outfit or not. if it is outfit then fall back to original approach
    if (
      this.shouldApplyUnbxdLogic &&
      !sortingAvailable &&
      displayableCatCount &&
      !categoryNameList[2] &&
      !isOutfitPage
    ) {
      // Caching all the L3 which are available under L2. During pagination, if the L3 gets exhust then we will remove that one from this array.
      this.bucketingConfig.L3Left = [...requiredChildren];
      // Caching all the available L3.
      this.bucketingConfig.availableL3 = [...requiredChildren];
      this.bucketingConfig.bucketingSeqScenario = true;
      // Forming the category path of the l2 which has been clicked.
      const categoryPathMapL2 = this.bucketingConfig.currL2NameList
        ? this.bucketingConfig.currL2NameList.map((item) => item.categoryId).join('>')
        : '';
      // Making the L2 call first
      return this.fetchFiltersAndCount(
        filtersAndSort,
        categoryPathMapL2,
        categoryNameList,
        location,
        pageNumber
      );
    }
    // if the bucketing is not required then we need to fallback to original approach.
    // If sorting is applied by the customer then we need to fallback to the original approach.

    return this.getProductsListingForUrlLocation(
      state,
      location,
      filterAndSortParam,
      sortBySelected,
      passedNavigationData,
      productCount,
      seoUrlPayload
    );
  }

  getProductsListingForUrlLocation(
    state,
    location,
    sortParam,
    sortBySelected,
    passedNavigationData,
    productCount,
    seoUrlPayload
  ) {
    const pageNumber = !Number.isNaN(location.pageNumber)
      ? Math.max(parseInt(location.pageNumber, 10))
      : 1;
    const filtersAndSort = sortBySelected
      ? sortParam
      : getPlpCutomizersFromUrlQueryString(location.search, seoUrlPayload);

    return this.getProductsListingInfo({
      state,
      filtersAndSort,
      pageNumber,
      location,
      passedNavigationData,
      startProductCount: productCount ? 0 : undefined,
      numberOfProducts: productCount,
    });
  }

  isExportBadge = (breadcrumbCatIds, navigationTree) => {
    return breadcrumbCatIds && breadcrumbCatIds.length
      ? this.getNavAttributes(navigationTree, breadcrumbCatIds, 'excludeAttribute')
      : '';
  };

  shortImage = (isSearchPage, breadcrumbCatIds, navigationTree) => {
    return !isSearchPage && breadcrumbCatIds && breadcrumbCatIds.length
      ? parseBoolean(this.getNavAttributes(navigationTree, breadcrumbCatIds, 'isShortImage'))
      : '';
  };

  isPageSearch = (location) => {
    return location.pathname.includes('search') || location.pathname.includes('featurebrand')
      ? isSearched()
      : isSearch();
  };

  isMatchSearch = (isSearchPage, searchTerm, location) => {
    return isSearchPage ? searchTerm : matchValue(isSearchPage, location.pathname);
  };

  getSeoForSearch = (isSearchPage, match) => {
    return isSearchPage ? match : getSeoKeywordOrCategoryIdOrSearchTerm(match);
  };

  getBucketingSeqConfig = (isSearchPage, bucketingSeqConfig) => {
    return isSearchPage ? {} : bucketingSeqConfig;
  };

  checkUnbxdLogic = (isSearchPage) => {
    return isSearchPage ? false : this.shouldApplyUnbxdLogic;
  };

  getPlpBucketDetails = ({
    bucketingSeqConfigArg,
    categoryNameList,
    categoryPathMap,
    catNameL3,
    isUnbxdSequencing,
    navigationTree,
    categoryIdArg,
    clickedL2,
    isSearchPage,
  }) => {
    let requiredChildren;

    const bucketingSeqConfig = bucketingSeqConfigArg;
    let categoryId = categoryIdArg;
    if (this.checkUnbxdLogic(isSearchPage)) {
      bucketingSeqConfig.requiredChildren = this.bucketingConfig.availableL3;
      bucketingSeqConfig.bucketingRequired = this.bucketingConfig.bucketingSeqScenario;
      bucketingSeqConfig.desiredL3 = getDesiredL3(catNameL3, this.bucketingConfig); // Fix me: Make catNameL3 available for all getProductsListingInfo calls.
      categoryId = getCatIdUbxd(categoryPathMap, categoryNameList);
      if (isUnbxdSequencing) bucketingSeqConfig.bucketingSeq = 'A/B-Test';
    } else {
      if (categoryNameList[1]) {
        requiredChildren = this.shouldBucktSeq(navigationTree, clickedL2.categoryId);
        const isBuktSeqReq = isRequiredChildrenExists(requiredChildren);
        bucketingSeqConfig.requiredChildren = requiredChildren;

        if (isUnbxdSequencing) {
          if (!isBuktSeqReq) {
            bucketingSeqConfig.bucketingSeq = 'A/B-Test';
          }
        } else if (isBuktSeqReq) {
          const catId = isCatIdBucketingSeq(categoryNameList, clickedL2);
          bucketingSeqConfig.bucketingSeq = `sort_${catId} asc,pop_score desc`;
        }
      }
      categoryId = getCatId(categoryNameList);
    }
    return { bucketingSeqConfig, categoryId };
  };

  getProductsListingFilters({ state, asPath, pageNumber, formData, location }) {
    const filtersAndSort = formData || getPlpCutomizersFromUrlQueryString(asPath);
    return this.getProductsListingInfo({
      state,
      filtersAndSort,
      pageNumber,
      location,
    });
  }

  composeBreadCrumbOnSSr = ({ state, location }) => {
    const isSearchPage = this.isPageSearch(location);
    const searchTerm = location.pathname.substr(11);
    const match = this.isMatchSearch(isSearchPage, searchTerm, location);
    const categoryKey = getCategoryKey(isSearchPage, match);
    const navigationTree = state.Navigation.navigationData || [];
    let categoryNameList = findCategoryIdandName(navigationTree, categoryKey).reverse();
    if (
      !categoryNameList.length &&
      typeof window !== 'undefined' &&
      window.PLP_CATEGORY_NAVIGATION_INFO
    ) {
      try {
        categoryNameList = JSON.parse(window.PLP_CATEGORY_NAVIGATION_INFO);
      } catch (e) {
        console.log(e);
      }
    }
    const staticBreadCrumbs = getBreadCrumb(categoryNameList);
    if (staticBreadCrumbs && staticBreadCrumbs.length > 0) {
      setLocalStorage({ key: 'staticPlpBreadCrumbs', value: JSON.stringify(staticBreadCrumbs) });
    }
    return staticBreadCrumbs;
  };

  processSTSUrl = (isSTSUrl, searchTerm) => {
    let processedSearchTerm = searchTerm;
    let subSearchQuery = '';

    if (isSTSUrl) {
      const urlWithoutPromotion = processedSearchTerm.substring('shop-this-store'.length);

      [subSearchQuery] = urlWithoutPromotion?.split('?') || [];
      const basePart = urlWithoutPromotion.split('?')[0];

      if (basePart) {
        if (basePart.includes('/')) {
          const [, part] = basePart.split('/');
          processedSearchTerm = part;
        } else {
          processedSearchTerm = basePart;
        }
      } else {
        processedSearchTerm = '*';
      }
    }

    return { searchTerm: processedSearchTerm, subSearchQuery };
  };

  getProductsListingInfo = ({
    state,
    filtersAndSort,
    pageNumber,
    // TODO - fix this for mobile APP - location needs to be defined
    location, // TODO - this is the prod code - location = routingInfoStoreView.getHistory(this.store.getState()).location,
    startProductCount,
    numberOfProducts,
    categoryPathMap,
    catNameL3,
    isLazyLoading,
    passedNavigationData,
  }) => {
    const isSearchPage = this.isPageSearch(location);
    let searchTerm = window.location.pathname.includes('featurebrand')
      ? '*'
      : location.pathname.substring(11);
    let subSearchQuery = '';
    const isPromotionalUrl = searchTerm?.includes(PROMOTIONAL_PRODUCTS_URL);
    const isSTSUrl = searchTerm?.includes('shop-this-store');
    if (isPromotionalUrl) {
      const urlWithoutPromotion = searchTerm.substring(PROMOTIONAL_PRODUCTS_URL.length);
      [subSearchQuery] = urlWithoutPromotion?.split('?') || [];
      searchTerm = '*';
    }
    if (isSTSUrl) {
      ({ searchTerm, subSearchQuery } = this.processSTSUrl(isSTSUrl, searchTerm));
    }

    const match = this.isMatchSearch(isSearchPage, searchTerm, location);
    const categoryKey = getCategoryKey(isSearchPage, match);
    const navigationTree = state.Navigation.navigationData || passedNavigationData;
    let categoryNameList = findCategoryIdandName(navigationTree, categoryKey).reverse();
    if (
      !categoryNameList.length &&
      typeof window !== 'undefined' &&
      window.PLP_CATEGORY_NAVIGATION_INFO
    ) {
      try {
        categoryNameList = JSON.parse(window.PLP_CATEGORY_NAVIGATION_INFO);
      } catch (e) {
        console.log(e);
      }
    }
    const categoryFilterArray = getCategoryFilters(categoryNameList);
    const breadCrumb = getBreadCrumb(categoryNameList);
    const breadcrumbCatIds = getBreadcrumbCatId(breadCrumb);
    const excludeBage = this.isExportBadge(breadcrumbCatIds, navigationTree);
    const isUnbxdSequencing =
      !isSearchPage; /* && abTestingStoreView.getIsUnbxdSequencing(state, match.params.listingKey) */
    const hasShortImage = this.shortImage(isSearchPage, breadcrumbCatIds, navigationTree);
    let categoryId;
    const clickedL2 = categoryNameList[1];
    const clickedl1 = categoryNameList[0];
    const bucketingSeqConfig = {};
    let filteredBucketingSeqConfig = {};

    if (!isSearchPage) {
      if (isRequiredL2L1(isUnbxdSequencing, this.checkUnbxdLogic(isSearchPage))) {
        bucketingSeqConfig.desiredL2 = getDesiredNav(clickedL2);
        bucketingSeqConfig.desiredl1 = getDesiredNav(clickedl1);
      }

      filteredBucketingSeqConfig = this.getPlpBucketDetails({
        bucketingSeqConfigArg: bucketingSeqConfig,
        categoryNameList,
        categoryPathMap,
        catNameL3,
        isUnbxdSequencing,
        navigationTree,
        categoryIdArg: categoryId,
        clickedL2,
      });
    }

    return {
      categoryFilterArray,
      seoKeywordOrCategoryIdOrSearchTerm: this.getSeoForSearch(isSearchPage, match),
      isSearch: isSearchPage,
      filtersAndSort,
      pageNumber,
      getImgPath: this.getImgPath,
      categoryId: filteredBucketingSeqConfig.categoryId,
      breadCrumbs: breadCrumb,
      bucketingSeqConfig: this.getBucketingSeqConfig(
        isSearchPage,
        filteredBucketingSeqConfig.bucketingSeqConfig
      ),
      getFacetSwatchImgPath: this.getFacetSwatchImgPath,
      isUnbxdSequencing,
      excludeBadge: excludeBage,
      startProductCount,
      numberOfProducts,
      cacheFiltersAndCount: false,
      extraParams: '',
      shouldApplyUnbxdLogic: this.checkUnbxdLogic(isSearchPage),
      hasShortImage,
      categoryNameList,
      isLazyLoading,
      isPromotionalUrl,
      subSearchQuery,
      navigationTree,
    };
  };

  updateBucketingConfig = (state, res, bucketingConfig, isPrefetched, isProcessedResponse) => {
    if (isProcessedResponse) {
      this.bucketingConfig = bucketingConfig;
    } else {
      const updatedBucketingConfig = this.bucketingLogic.updateBucketingParamters(state, res, {
        ...this.bucketingConfig,
        ...bucketingConfig,
      });
      ({ ...this.bucketingConfig } = { ...updatedBucketingConfig });
      if (this.bucketingConfig.availableL3.length && !isPrefetched) {
        res.totalProductsCount = getTotalProductsCount(this.bucketingConfig.availableL3);
      }
    }
    return this.bucketingConfig;
  };

  getProductsListingMoreProducts(
    state = {},
    location,
    productsFetchedTillNow,
    productCount,
    isLowerEndDevice
  ) {
    const lastLoadedPageNumber = getLastLoadedPageNumber(state, productsFetchedTillNow);

    if (
      productsFetchedTillNow >= (state.ProductListing && state.ProductListing.totalProductsCount)
    ) {
      return null; // nothing more to load
    }

    const { appliedFiltersIds } = state.ProductListing;
    // TODO - take the fallback from sort array once sort functionality is merged
    const sort = (state.ProductListing && state.ProductListing.appliedSortId) || '';

    const appliedFiltersAndSort = { ...appliedFiltersIds, sort };

    const PRODUCTS_PER_LOAD_PLP = PRODUCTS_PER_LOAD;

    return this.getProductsListingInfo({
      state,
      filtersAndSort: appliedFiltersAndSort,
      pageNumber: lastLoadedPageNumber + 1,
      location,
      isLazyLoading: true,
      startProductCount: productsFetchedTillNow,
      numberOfProducts: isLowerEndDevice ? productCount : PRODUCTS_PER_LOAD_PLP,
    });
  }

  getProductsCountToBFetched = (
    isLowerEndDevice,
    bucketingProductsToFetchPerLoad,
    productCount
  ) => {
    if (isLowerEndDevice) {
      return bucketingProductsToFetchPerLoad < productCount
        ? bucketingProductsToFetchPerLoad
        : productCount;
    }
    return bucketingProductsToFetchPerLoad;
  };

  /**
   * @funtion getMoreBucketedProducts We have a functionality on PLP page of lazy load and the next set of products are loaded when the user scrolls
   *          down. Under DTN:6529 , we need to check if the lazy load is happening on the scenario where the bucketing is required. If it does then
   *          we need to trigger multiple L3 calls on the basis of what all L3's are left in this.bucketingConfig.L3left variable.
   */

  getMoreBucketedProducts = (
    state,
    location,
    productLoadedTillNow,
    productCount,
    isLowerEndDevice
  ) => {
    // if (isOnSeoPlp()) return Promise.resolve(); // scrolling is only supported on pages intended for human users, not for crawlers
    // const state = this.store.getState();
    const noOfProductsToBFetched = this.getProductsCountToBFetched(
      isLowerEndDevice,
      this.bucketingConfig.productsToFetchPerLoad,
      productCount
    );
    const sort = getAppliedSortId(state) || '';
    // If this is not a bucketing scenario and if the sort parameter is applied then we need to follow the original approach.
    if (this.shouldApplyUnbxdLogic && this.bucketingConfig.bucketingSeqScenario && !sort) {
      // If no L3 are left to load means we have brought all the products in current L2, then we need to resolve the promise.
      if (!this.bucketingConfig.L3Left.length) {
        return null; // nothing more to load
      }
      const { appliedFiltersIds } = state.ProductListing;
      const categoryNameList = [...this.bucketingConfig.currL2NameList];
      // Pushing the first L3 available in L3left variable
      categoryNameList.push(getRequiredCategoryData(this.bucketingConfig.L3Left[0], true));
      const appliedFiltersAndSort = { ...appliedFiltersIds, sort };
      // Constructing the category path of the L3
      const categoryPathMap = categoryNameList
        ? categoryNameList.map((item) => item.categoryId).join('>')
        : '';
      return this.getProductsListingInfo({
        state,
        filtersAndSort: appliedFiltersAndSort,
        pageNumber: false,
        // location: routingInfoStoreView.getHistory(this.store.getState()).location,
        location,
        startProductCount: this.bucketingConfig.start,
        numberOfProducts: noOfProductsToBFetched,
        categoryPathMap,
        isLazyLoading: true,
      });
    }
    return this.getProductsListingMoreProducts(
      state,
      location,
      productLoadedTillNow,
      productCount,
      isLowerEndDevice
    );
  };
}
